<div class="list-container">
  <rask-list [data]="anvandare" key="userId">
    <rask-list-column header="Namn" field="firstName" [sortable]="true">
      <ng-template let-row="row">
        <a href="#" (click)="open($event, row)">{{row.firstName}} {{row.lastName}}</a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Användar-id" field="userName" [sortable]="true"></rask-list-column>
    <rask-list-column header="Email" field="email" [sortable]="true"></rask-list-column>
    <rask-list-column header="Användare låst" field="locked" [sortable]="true"></rask-list-column>
    <rask-list-column header="Användare finns i RASK" field="sveaEmployee" [sortable]="true">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Typ" field="isGuest" [sortable]="true">
      <ng-template let-value>
        @if (value) {
          <span>Gäst</span>
        }
        @if (value === false) {
          <span>Användare</span>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>